import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Button, Grid, Group, IconButton, Layout, Page, Tree } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useToast, useModal, useTree, usePopup, usePage } from "@/comn/hooks";
import { LayoutGroup } from "framer-motion";
import { APIS, SF_APRV_RQST_PPUP_INFO, SG_APRV_PATH_RQST_LIST, SG_APRV_USR_LIST } from "./service/AprvService";

/*
 * Approval Request
 * !== 결재 요청 ==!
 */
export const RoleAprvRqstDrt = (props: any): any => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const tree = useTree(); // Tree Hook !== Tree Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const { closeModal } = useModal();
    const { id, params } = props;

    const {
        aplyUsrDmnId,
        bsopClsfCd,
        afPrcssUrlAddr,
        scrnDocCd,
        aprvId,
        aprvAfPrcssCfgnId,
        rtrnAfPrcssCfgnId,
        cnclAfPrcssCfgnId,
        rjctAfPrcssCfgnId,
        prevStageRtrnUseYn,
        itsfAprvYn,
        delYn,
        aprvReffId,
        aprvRqstTtleNm,
        aprvRqstCn,
        aprvUsrList,
        aprvPrcssPathMgmtId,
        testCallback,
        rjctStatUseYn,
        docNo,
        authAprvRqstList,
    } = params;

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Approval Request Popup Information Form !== 결재 요청 팝업 정보 form ==!
        aprvRqstPpupInfo: useForm({
            defaultSchema: SF_APRV_RQST_PPUP_INFO,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getDclaDocInfo: useFetch({
            api: () => APIS.getDclaDocInfo(scrnDocCd),
            enabled: !!scrnDocCd,
            onSuccess: (data) => {
                const getDataInfo = data.dclaDocInfo.content;
                if (comnUtils.isEmpty(getDataInfo)) {
                    toast.showToast({ type: "error", content: "msg.osc.00043" });
                    closeModal(id);
                    return;
                }
                form.aprvRqstPpupInfo.setValues(getDataInfo);
                form.aprvRqstPpupInfo.setValue(
                    "aprvRqstTtleNm",
                    !comnUtils.isEmpty(aprvRqstTtleNm) ? aprvRqstTtleNm : getDataInfo.docNm,
                );
                form.aprvRqstPpupInfo.setValue("aplyUsrDmnId", aplyUsrDmnId);
                form.aprvRqstPpupInfo.setValue("aprvRqstCn", aprvRqstCn);
                //form.aprvRqstPpupInfo.setValue("usrDmnId", aprvUsrList.join(","));
                form.aprvRqstPpupInfo.setValue("bsopClsfCd", bsopClsfCd);
                form.aprvRqstPpupInfo.setValue("afPrcssUrlAddr", afPrcssUrlAddr);
                form.aprvRqstPpupInfo.setValue("scrnDocCd", scrnDocCd);
                form.aprvRqstPpupInfo.setValue("aprvAfPrcssCfgnId", aprvAfPrcssCfgnId);
                form.aprvRqstPpupInfo.setValue("rtrnAfPrcssCfgnId", rtrnAfPrcssCfgnId);
                form.aprvRqstPpupInfo.setValue("cnclAfPrcssCfgnId", cnclAfPrcssCfgnId);
                form.aprvRqstPpupInfo.setValue("rjctAfPrcssCfgnId", rjctAfPrcssCfgnId);
                form.aprvRqstPpupInfo.setValue("prevStageRtrnUseYn", prevStageRtrnUseYn);
                form.aprvRqstPpupInfo.setValue("itsfAprvYn", itsfAprvYn);
                form.aprvRqstPpupInfo.setValue("delYn", delYn);
                form.aprvRqstPpupInfo.setValue("aprvReffId", aprvReffId);
                form.aprvRqstPpupInfo.setValue("aprvPrcssPathMgmtId", aprvPrcssPathMgmtId);
                form.aprvRqstPpupInfo.setValue("rjctStatUseYn", rjctStatUseYn);
                form.aprvRqstPpupInfo.setValue("docNo", docNo);
                form.aprvRqstPpupInfo.setValue("authAprvRqstList", authAprvRqstList);

                // KNH 설정값을 전달해 주고 업무에서 직접 결재 요청을 전달하도록 변경
                // fetch.saveAuthAprvRqstInfo.fetch(form.aprvRqstPpupInfo.getValues());
                testCallback(form.aprvRqstPpupInfo.getValues());
                closeModal(id);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        // Create Organization Information !== 결재 요청 저장 ==!
        saveAuthAprvRqstInfo: useFetch({
            api: (data: any) => APIS.saveAuthAprvRqstInfo(data),
            enabled: false,
            onSuccess: (data: any) => {
                const getAprvId = data["aprvInfo"].content.aprvId; // !== 결재 요청시 생성된 결재 ID 가져오기 ==!
                testCallback({
                    pgeUid: pgeUid,
                    menuId: menuId,
                    bsopClsfCd: bsopClsfCd,
                    afPrcssUrlAddr: afPrcssUrlAddr,
                    scrnDocCd: scrnDocCd,
                    aprvPrcssStatCd: "A01",
                    aprvId: getAprvId,
                });

                closeModal(id);
            },

            onError: (error) => {
                if (error.response.status === 500) {
                    const data = error.response.data;

                    modal.openModal({
                        content: data.errorMessage,
                        onClose: () => {
                            modal.postMessage({
                                aprvId: "",
                            });
                        },
                    });
                    closeModal(id);
                    return;
                }

                toast.showToast({ type: "error", content: "msg.osc.00045" }); // An error occurred. !== 에러가 발생했습니다! ==!
                closeModal(id);
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        oninit: () => {
            fetch.getDclaDocInfo.fetch();
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.oninit();
        tree.tree._tree.current._checkbox = false;
    }, []);

    return null;
};
